export default __webpack_public_path__ + "static/media/SPECTRAL RAIJIN.19c481b6.jpg";